import { reatomAsync, withDataAtom } from "@reatom/async";
import { withIsLoadingAtom } from "src/common/pipes";
import { fetchProductDetail } from "src/store/fetchers/getProductDetailRequest";

export const getProductDetailFromStorage = reatomAsync(
  async (_ctx, productId: number) => fetchProductDetail(productId),
  "getProductDetailFromStorage",
).pipe(withDataAtom(null), withIsLoadingAtom());
